import { render, staticRenderFns } from "./UserManagement.vue?vue&type=template&id=200b68bf&scoped=true&"
import script from "./UserManagement.vue?vue&type=script&lang=js&"
export * from "./UserManagement.vue?vue&type=script&lang=js&"
import style0 from "./UserManagement.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./UserManagement.vue?vue&type=style&index=1&id=200b68bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200b68bf",
  null
  
)

export default component.exports